import Route from '@ember/routing/route';

export default class EventsRoute extends Route {}
